import moment from "moment-timezone";

export default function hasApptExpired(sentAt, timezone) {
  const hour = 3600000;
  let sentAtTime = new Date(moment.tz(sentAt, timezone).format());
  let expiresAtTime = sentAtTime.getTime() + hour;

  if (Date.now() > expiresAtTime) {
    return true;
  } else {
    return expiresAtTime;
  }
}
